// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--WMEug","table":"table--v1Il7"};